import { Component, computed, inject, input, output } from '@angular/core';
import { EnpsComponent } from '@common/components/base/enps-component';
import { NomWebServicesJson } from '@common/services/nom-web-services-json';
import { VisualStateService } from '@common/services/visual-state-service';
import { GlobalTablesService } from '@src/suite/common/services/global-tables-service';
import { AppService } from '@suite/app.service';

export type ListDropDownLabelPosition = 'before' | 'after';

@Component({
    selector: 'st-list-drop-down',
    templateUrl: './list-drop-down.html',
    styleUrls: ['./list-drop-down.scss'],
    host: {
        class: 'list-drop-down',
    },
})
export class ListDropDownComponent extends EnpsComponent {
    appService = inject(AppService);
    nomWebServicesJson = inject(NomWebServicesJson);
    visualStateService = inject(VisualStateService);
    globalTablesService = inject(GlobalTablesService);

    value = input<any>();

    list = input<any[]>();
    label = input('');
    disabled = input(false);
    labelPosition = input<ListDropDownLabelPosition>('before');
    mobileIcon = input('arrow_drop_down');

    valueOutput = output<any>();

    labelDisplay = computed(() => {
        if (this.visualStateService.isLessThanMedium) return this.label();
        if (this.labelPosition() === 'after') {
            return `${this.displayValue()} ${this.label()}`;
        }
        return `${this.label()} ${this.displayValue()}`;
    });

    get isRTL() {
        return this.globalTablesService.getRtl();
    }

    get showFullButton(): boolean {
        return !this.visualStateService.isLessThanSmall;
    }

    displayValue = computed(() => {
        let isObject: boolean = false;
        let currentValue = this.value() || '';
        if (typeof this.value() === 'object') {
            // On search view sort by is object, not a string
            isObject = true;
            currentValue = JSON.stringify(currentValue);
        }
        if (this.list() && this.list().length > 0) {
            const selectedValue = this.list().filter(item => {
                if (isObject) {
                    const itemValue: string = JSON.stringify(item.id);
                    return currentValue === itemValue;
                }
                return item.id === this.value();
            });
            return selectedValue[0]?.title || this.value() || '';
        }
    });

    public valueChanged(v: any) {
        if (v && typeof v.id !== 'undefined' && v.id !== null) {
            this.valueOutput.emit(v.id);
        }
    }
}
